var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7389 6.98883L7.90068 0.155626C7.85145 0.106293 7.79296 0.0671542 7.72858 0.0404498C7.6642 0.0137455 7.59519 0 7.52549 0C7.45579 0 7.38677 0.0137455 7.32239 0.0404498C7.25801 0.0671542 7.19953 0.106293 7.15029 0.155626L0.312109 6.98883C0.112891 7.18805 0 7.45865 0 7.74088C0 8.32691 0.476465 8.80338 1.0625 8.80338H1.78301V13.6793C1.78301 13.9731 2.02041 14.2105 2.31426 14.2105H6.46299V10.4918H8.32236V14.2105H12.7367C13.0306 14.2105 13.268 13.9731 13.268 13.6793V8.80338H13.9885C14.2707 8.80338 14.5413 8.69215 14.7405 8.49127C15.1539 8.07623 15.1539 7.40387 14.7389 6.98883Z",
    fill: "#3A61FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.897d97836a9ba5515cd9d63a8e00a864.svg";
export { ForwardRef as ReactComponent };